<template>
  <section class="hrv-hero hrv-hero--split-quick" aria-label="Главный баннер">
    <div class="hr-container">
      <div class="hrv-hero__split">
        <div class="hrv-hero__left">
          <p class="hrv-hero__eyebrow">{{ data.eyebrow }}</p>
          <h1 class="hrv-hero__title">
            <span class="hrv-hero__title-lead">{{ data.titleLine1 }}</span>
            <span class="hrv-hero__title-brand">{{ data.titleBrand }}</span>
          </h1>
          <p v-if="data.subtitle" class="hrv-hero__subtitle">{{ data.subtitle }}</p>
          <p class="hrv-hero__desc hrv-hero__desc--wrap">{{ data.description }}</p>
          <div class="hrv-hero__actions">
            <router-link
              v-for="action in data.actions"
              :key="action.label"
              class="hr-btn"
              :class="action.primary ? 'hr-btn--primary' : 'hr-btn--outline'"
              :to="action.to"
            >
              {{ action.label }}
            </router-link>
          </div>
          <ul v-if="quickLinks && quickLinks.length" class="hrv-quick-inline" aria-label="Быстрые ссылки">
            <li v-for="item in quickLinks" :key="item.label">
              <router-link class="hrv-quick-inline__item" :to="item.to">
                <span class="hrv-quick-inline__icon">
                  <HrIcon :name="item.icon" :image="item.iconImage" />
                </span>
                <span class="hrv-quick-inline__label">{{ item.label }}</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="hrv-hero__right" aria-hidden="true">
          <img :src="data.image" :alt="data.imageAlt || ''" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HrIcon from '../components/HrIcon.vue'

export default {
  name: 'HrHeroSplitQuick',
  components: { HrIcon },
  props: {
    data: { type: Object, required: true },
    quickLinks: { type: Array, default: () => [] },
  },
}
</script>
